module.exports = __webpack_public_path__ + "media/images/boat-2x-f01ab99852dd24828473232ca439e668.png";